import Typeahead from './typeahead'

$(() => new Typeahead('js-ontology-light-typeahead'))
